import { BaseEntity } from '../../../app/core';

export class DriverList extends BaseEntity {
    name: string;
    lastName: string;
    file: string;
    age: number;
    startInBussiness: Date;
    startInBussinessString: string;
    licenseExpiration: Date;
    licenseExpirationString: string;
    licenseExpirationSoon: boolean;

    constructor(startInBussiness: Date, licenseExpiration: Date) {
        super();
        this.startInBussinessString = this.dateToString(startInBussiness);
        this.licenseExpirationString = this.dateToString(licenseExpiration);

        if (licenseExpiration) {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

            const expiration = new Date(licenseExpiration);
            expiration.setHours(0, 0, 0, 0);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const diffDays = Math.round((expiration.getTime() - today.getTime()) / (oneDay));

            this.licenseExpirationSoon = (diffDays < 60);
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/driver-list.ts